<template>
  <v-card>
    <v-tabs
      fixed-tabs
      next-icon="mdi-arrow-right-bold-box-outline"
      prev-icon="mdi-arrow-left-bold-box-outline"
      show-arrows
    >
      <v-tab>
        Company
      </v-tab>
      <v-tab>
        Users
      </v-tab>
      <v-tab>
        Program
      </v-tab>
      <v-tab>
        Email Template
      </v-tab>

      <v-tab-item>
        <Client />
      </v-tab-item>
      <v-tab-item>
        <UserList />
      </v-tab-item>
      <v-tab-item>
        <ProgramList />
      </v-tab-item>
      <v-tab-item>
        <EmailList />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import Client from '../components/forms/Client.vue'
import UserList from '../components/userList.vue'
import ProgramList from '../components/programList.vue'
import EmailList from '../components/emailList.vue'

export default {
  name: 'settings',

  components: {
    Client,
    UserList,
    ProgramList,
    EmailList,
  },

  data() {
    return {
      height: 0,
    }
  },

  mounted() {
    this.onResize()
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 280
    },
  },
}
</script>
